<label class="switch" [ngStyle]="{ 'font-size': size + 'px' }">
	<input
		type="checkbox"
		[value]="switchOn"
		[checked]="
			((invertToggle === undefined || invertToggle === false) && switchOn === true) ||
			(invertToggle !== undefined && invertToggle === true && switchOn === false)
		"
		(change)="changeSwitch()" />
	<span class="slider"></span>
</label>
